module.exports = __webpack_public_path__ + "img/logo.odp.e0be489e.png";